import { createFileRoute } from '@tanstack/react-router';

import { CreatePost } from '#modules/finder/features/posts/components/CreatePost';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/discover/create'
)({
  component: CreatePost,
  validateSearch: (
    search: Record<string, unknown>
  ): { gameId?: string; blog?: string; newUser?: string | boolean } => ({
    gameId: typeof search.gameId === 'string' ? search.gameId : undefined,
    blog: typeof search.blog === 'string' ? search.blog : undefined,
    newUser:
      typeof search.newUser === 'string' || typeof search.newUser === 'boolean'
        ? search.newUser
        : undefined,
  }),
  ssr: false,
});
